<script setup>
import { ref, onMounted, defineProps, defineModel, watch } from 'vue' 
import debounce from 'lodash.debounce'
import DefectApi from '@/services/DefectApi'

const crtProps = defineProps(['label', 'variant', 'density', 'hideDetails', 'strict', 'isLoaded']);
const defects = ref([])
const model = defineModel({type: Object, default: { defectId: 0, name: ""} })
const selectedDefect = ref()  
const loading = ref(false)

const searchDefects = debounce(async (term) => {

    loading.value = true
    DefectApi.search({ offset: 0, limit: 25, search: term }).then((response) => {
        if (response && response.data && Array.isArray(response.data.defects)) {
            defects.value = response.data.defects;   
        }
    }).finally(() => {
        loading.value = false
         if(term) {
            selectedDefect.value = term
        }
    })
})

onMounted(() => {
    if(model.value && model.value.defectId > 0 && model.value.name) {
        searchDefects(model.value.name)
    }
    else {
        searchDefects(undefined)
    }
})

const handleDefectUpdate = (value) => {
    let defect = defects.value.find(x => x.defectId == value);
    if(defect) {
        model.value = defect;
    }
    else {
        model.value = { defectId: 0, name: ""};
    }
}

watch(model, (value) => {
    
    if(value && value.defectId > 0 && value.name) {
        searchDefects(value.name)
    }
    else {
        
        searchDefects(undefined)
        selectedDefect.value = null
        model.value = null
    }
});

</script>

<template>
    <div :class="crtProps.class">
            <v-autocomplete
                :variant="crtProps.variant ? crtProps.variant : 'solo'" 
                item-title="name"
                item-value="defectId" 
                :density="crtProps.density ? crtProps.density : 'compact'" 
                :label="crtProps.label"
                :loading="loading"
                :items="defects"
                v-model="selectedDefect"
                @update:search="searchDefects"
                @update:model-value="handleDefectUpdate"
                autocomplete="one-time-code"
                :hide-details="crtProps.hideDetails != undefined ? crtProps.hideDetails : true"
                :clearable="true">
            </v-autocomplete>
        </div>
</template>